module.exports = __webpack_public_path__ + "static/img/yanan1.87f8e041.jpg";